import { FC } from "react";
import styles from "./Price.module.css";

interface PriceProps {
  listPrice: string | number;
  offerPrice?: string | number;
  insPrice?: string | number;
  listPriceClassName?: string;
  displayPriceClassName?: string;
  loading?: boolean;
  included?: boolean;
  includedLabel?: string;
}

export const Price: FC<PriceProps> = ({
  listPrice,
  offerPrice,
  insPrice,
  listPriceClassName,
  displayPriceClassName,
  loading = false,
  included = false,
  includedLabel = "Included",
}) => {
  // Determine which price to display (insPrice if available, otherwise offerPrice)
  const displayPrice = insPrice ?? offerPrice;
  const isInsurance = insPrice !== undefined && insPrice !== null;

  const listPriceClasses =
    `${styles.listPrice} ${isInsurance ? styles.insurancePrice : ""} ${listPriceClassName || ""}`.trim();
  const displayPriceClasses =
    `${styles.displayPrice} ${isInsurance ? styles.insurancePrice : ""} ${displayPriceClassName || ""}`.trim();

  if (loading) {
    return (
      <div className={styles.priceContainer}>
        <span className={styles.loader}></span>
      </div>
    );
  }

  if (included) {
    return (
      <div className={styles.priceContainer}>
        <span className={listPriceClasses}>{listPrice}</span>
        <span className={`${displayPriceClasses} ${isInsurance ? styles.includedLabel : ""}`}>
          {includedLabel}
        </span>
      </div>
    );
  }

  return (
    <div className={styles.priceContainer}>
      {displayPrice && <span className={listPriceClasses}>{listPrice}</span>}
      <span className={displayPriceClasses}>
        {displayPrice ? displayPrice : listPrice}
      </span>
    </div>
  );
};
